function generateUuid() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function generateDownloadFileName(extension = "xlsx") {
  const normalizedExtension = String(extension || "xlsx").replace(/^\./, "");
  return `${generateUuid()}.${normalizedExtension}`;
}

function downloadBytesFile(bytes, fileName, mimeType) {
  const blob = new Blob([bytes], {
    type:
      mimeType ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
}

function openBytesFile(bytes, mimeType) {
  const blob = new Blob([bytes], { type: mimeType || "application/pdf" });
  const objectUrl = window.URL.createObjectURL(blob);
  window.open(objectUrl, "_blank");
}

export const fileUtils = {
  generateDownloadFileName,
  downloadBytesFile,
  openBytesFile,
};
